import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseService } from './base.service';
import { IResponse } from 'src/app/shared/models/app';
import { CacheResolverService } from '../cache/cache-resolver.service';
import { AccountService } from './account.service';
import {  Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PrincipalService extends BaseService {
  _identity: any;
  _authenticated = false;
  authenticated$: Subject<boolean> = new Subject();

  /*********************Properties*********************/

  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(protected http: HttpClient, private cache: CacheResolverService,
    private accountService: AccountService,
    private cacheService: CacheResolverService) {
    super(http);
  } 

  identity(shipTo = null) {

    return new Promise((resolve, reject) => {
       this.accountService.get(shipTo).subscribe((response: IResponse) => {
        if (response && response.data) {
          this._identity = response.data;
       
        }
        resolve(this._identity);
      });
    });

  }

  hasPermission(permission: any) {
    const authenticated = this.cacheService.get('Authenticated');
    if (authenticated) {
      return false;
    }
    return this.identity().then((response: any) => {
      return Promise.resolve(response.data.permissions && response.data.permissions.indexOf(Number(permission)) !== -1);
    })
      .catch(error => {

        return Promise.resolve(false);
      });
  }

  auditLogoutDetails(logoutMethod: any,userId: any,userEmail: any){   
    const url = this.apiConfig.user + "/logout";          
    const reqType ={
      logout:1201,
      WO:1
    }
    const userAgent = window.navigator.userAgent;        
    const requestBody = {
      operationType: reqType.logout, 
      appType: reqType.WO, 
      userDetailNum: userId
    }
    return super.post(url,requestBody,{
      headers: {
        'user-num':userId,
        'user-id':userEmail,
        'Agent-Type':userAgent,
        'logout-method':logoutMethod                
      }
    });
  }

}
